export const MAX_CHARACTERS = {
  LIMIT: 400,
  OVER: 401
};